import React, { useState, useCallback, useEffect } from 'react';

import { useAuth } from 'Context/auth';
import { createGlobalStyle } from 'styled-components';
import { entries } from 'lodash';
import { useUser } from 'Context/user';
import { ButtonIcon, IconEditCopy } from '@make.tv/lib-web-uicomponents';
import { copyToClipboard } from 'Services/data-table.service';
import { readServerTimestamp } from 'Components/current-time';

const GlobalStyle = createGlobalStyle`
  .footer-ver-div {
    display: inline-block;
    vertical-align: super;
  }

  .ver-root {
    --transition-time: 100ms;
    animation: fadein var(--transition-time) ease-in;
    opacity: 1;
    transition: opacity var(--transition-time) ease-out;
  }

  .ver-icon-btn > span:hover {
    background-color: #33393e !important;
    color: #d5d6d8 !important;
  }

  .ver-icon-btn:hover {
    cursor: pointer;
  }

  .ver-section {
    margin: 0 8px;
    color: #8c8c8c;
  }

  .ver-section::before {
    cursor: not-allowed;
  }

  .ver-section + .ver-section {
    margin-left: 0px;
    padding-left: 8px;
    border-left: 1px solid #34383d;
  }

  .ver-name:after {
    content: ":";
    margin-right: 4px;
  }

  .ver-copy-btn {
    position: absolute;
    margin: -7px;
  }

  @keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
`;

export const VersionIndicator = ({ mainVersion, detailedVerion, isloading }) => {
  const { isAuthenticated } = useAuth();
  const [expanded, setExpanded] = useState(false);
  const [hidden, setHidden] = useState(true);

  const {
    user,
  } = useUser();

  const toggleExpand = useCallback(() => {
    if (expanded) {
      setHidden(true);
    } else setHidden(false);
    setExpanded(!expanded);
  }, [expanded]);

  useEffect(() => {
    if (!isAuthenticated && expanded) {
      toggleExpand();
    }
  }, [expanded, isAuthenticated, toggleExpand]);

  const copyData = (time, userName) => {
    const initText = `
      Time-stamp: ${time}
      User: ${userName}
      Version: ${mainVersion}
      Detailed-version: ${JSON.stringify(detailedVerion)}
    `;
    copyToClipboard(initText);
  };

  const renderSection = (name, value) => (
    <span key={name} className="ver-section ver-root">
      <span className="ver-name">{name}</span>
      <span>{value}</span>
    </span>
  );

  if (expanded) {
    return (
      <div
        className="footer-ver-div"
        style={{ display: hidden ? 'none' : '', cursor: 'pointer' }}
        onClick={isloading ? {} : toggleExpand}
      >
        <GlobalStyle />
        {entries(detailedVerion).map(([name, value]) => renderSection(name, value))}
        <span className="ver-copy-btn">
          <ButtonIcon
            className="ver-icon-btn"
            icon={<IconEditCopy />}
            color="secondary"
            onClick={(e) => {
              e.stopPropagation();
              // eslint-disable-next-line camelcase
              copyData(readServerTimestamp(), user?.user_id);
            }}
          />
        </span>
      </div>
    );
  }

  return (
    <div
      className="footer-ver-div"
      style={{ display: !hidden ? 'none' : '', cursor: isAuthenticated ? 'pointer' : 'default' }}
      onClick={isAuthenticated ? toggleExpand : null}
    >
      <GlobalStyle />
      <span className="ver-section ver-root">
        <span className="ver-name">Version</span>
        <span>{mainVersion}</span>
      </span>
    </div>
  );
};
